var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('vue-core-video-player',{ref:"videoPlayer",attrs:{"src":_vm.videoSource,"cover":_vm.cover,"title":_vm.title,"preload":"nona","loop":_vm.loop}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }